import { ChildGender } from "~/types";
import { formatAge } from "./formatAge";
import { formatGender } from "./formatGender";

/**
 * Formats age and gender into a Romanian description
 * Examples: "băiețel nou-născut", "fetiță de 2 ani", "băiețel de 5 ani"
 */
export const formatAgeGenderDescription = (
  age: number | null | undefined,
  gender: ChildGender | undefined,
): string => {
  const ageNum = age ?? 0;

  // Determine gender text using existing formatGender utility
  const genderText = formatGender(gender);

  if (!genderText || genderText === "-") {
    return "";
  }

  // Format age text
  if (ageNum === 0) {
    return formatAge(0, gender);
  } else if (ageNum === 1) {
    return `${genderText} de 1 anișor`;
  } else if (ageNum < 3) {
    return `${genderText} de ${ageNum} anișori`;
  } else {
    return `${genderText} de ${ageNum} ani`;
  }
};
